module.exports = __webpack_public_path__ + "static/media/storeAlone.db05b7be.png";